import { get, put } from "../../utils/httpClient";

const systemPreferencesService = () => {
  const prefixApi = "duedates/systempreferences";

  const getSystemPreferences = async () => {
    return await get(`/${prefixApi}`);
  };

  const updateSystemPreferences = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  return {
    getSystemPreferences,
    updateSystemPreferences,
  };
};

export default systemPreferencesService;
